/* tslint:disable */
/* eslint-disable */
/**
 * Locations Adapter Zara
 * Rest services to get drop points and SOLR integrated services.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: gabrielsa@inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AdditionalData
 */
export interface AdditionalData {
    /**
     * 
     * @type {string}
     * @memberof AdditionalData
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface AddressField
 */
export interface AddressField {
    /**
     * Flattened representation of Address entity fields.
     * @type {string}
     * @memberof AddressField
     */
    'field'?: AddressFieldFieldEnum;
    /**
     * 
     * @type {Int32DataType}
     * @memberof AddressField
     */
    'int32DataType'?: Int32DataType;
    /**
     * 
     * @type {Int64DataType}
     * @memberof AddressField
     */
    'int64DataType'?: Int64DataType;
    /**
     * 
     * @type {StringDataType}
     * @memberof AddressField
     */
    'stringDataType'?: StringDataType;
    /**
     * 
     * @type {BooleanDataType}
     * @memberof AddressField
     */
    'booleanDataType'?: BooleanDataType;
    /**
     * 
     * @type {ComplexObjectDataType}
     * @memberof AddressField
     */
    'complexDataType'?: ComplexObjectDataType;
    /**
     * 
     * @type {CollectionDataType}
     * @memberof AddressField
     */
    'collectionDataType'?: CollectionDataType;
    /**
     * Field sorting order.
     * @type {number}
     * @memberof AddressField
     */
    'order'?: number;
    /**
     * Human readable localizations of the field type.
     * @type {Array<Localization>}
     * @memberof AddressField
     */
    'localizedName'?: Array<Localization>;
    /**
     * Text that facilitates the understanding of the format or semantics of the field.
     * @type {Array<Localization>}
     * @memberof AddressField
     */
    'helpText'?: Array<Localization>;
    /**
     * Indicates whether this field is optional or not. If true, and the field is empty, no validation is done on the field.
     * @type {boolean}
     * @memberof AddressField
     */
    'optional'?: boolean;
    /**
     * Flattened representation of Geopolitical Subdivision Level values.
     * @type {string}
     * @memberof AddressField
     */
    'kind'?: AddressFieldKindEnum;
}

export const AddressFieldFieldEnum = {
    AddressFieldUnspecified: 'ADDRESS_FIELD_UNSPECIFIED',
    Alias: 'ALIAS',
    AddressLine: 'ADDRESS_LINE',
    CountryCode: 'COUNTRY_CODE',
    GeopoliticalSubdivisions: 'GEOPOLITICAL_SUBDIVISIONS',
    GeopoliticalSubdivisionsLevel1: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_1',
    GeopoliticalSubdivisionsLevel1Id: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_1_ID',
    GeopoliticalSubdivisionsLevel1Freeform: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_1_FREEFORM',
    GeopoliticalSubdivisionsLevel2: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_2',
    GeopoliticalSubdivisionsLevel2Id: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_2_ID',
    GeopoliticalSubdivisionsLevel2Freeform: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_2_FREEFORM',
    GeopoliticalSubdivisionsLevel3: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_3',
    GeopoliticalSubdivisionsLevel3Id: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_3_ID',
    GeopoliticalSubdivisionsLevel3Freeform: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_3_FREEFORM',
    GeopoliticalSubdivisionsLevel4: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_4',
    GeopoliticalSubdivisionsLevel4Id: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_4_ID',
    GeopoliticalSubdivisionsLevel4Freeform: 'GEOPOLITICAL_SUBDIVISIONS_LEVEL_4_FREEFORM',
    Location: 'LOCATION',
    LocationStreetName: 'LOCATION_STREET_NAME',
    LocationStreetNumber: 'LOCATION_STREET_NUMBER',
    LocationFloor: 'LOCATION_FLOOR',
    LocationDoor: 'LOCATION_DOOR',
    LocationDoorCode: 'LOCATION_DOOR_CODE',
    LocationPostalCode: 'LOCATION_POSTAL_CODE',
    ContactInformation: 'CONTACT_INFORMATION',
    ContactInformationEmail: 'CONTACT_INFORMATION_EMAIL',
    ContactInformationFirstName: 'CONTACT_INFORMATION_FIRST_NAME',
    ContactInformationMiddleName: 'CONTACT_INFORMATION_MIDDLE_NAME',
    ContactInformationLastName: 'CONTACT_INFORMATION_LAST_NAME',
    ContactInformationHonorific: 'CONTACT_INFORMATION_HONORIFIC',
    ContactInformationPhones: 'CONTACT_INFORMATION_PHONES',
    ContactInformationPhonePrefix: 'CONTACT_INFORMATION_PHONE_PREFIX',
    ContactInformationPhoneNumber: 'CONTACT_INFORMATION_PHONE_NUMBER',
    AdditionalInformation: 'ADDITIONAL_INFORMATION'
} as const;

export type AddressFieldFieldEnum = typeof AddressFieldFieldEnum[keyof typeof AddressFieldFieldEnum];
export const AddressFieldKindEnum = {
    KindUnspecified: 'KIND_UNSPECIFIED',
    State: 'STATE',
    Emirate: 'EMIRATE',
    County: 'COUNTY',
    Colonia: 'COLONIA',
    Area: 'AREA',
    Locality: 'LOCALITY',
    District: 'DISTRICT',
    Governorate: 'GOVERNORATE',
    Department: 'DEPARTMENT',
    Province: 'PROVINCE',
    Region: 'REGION',
    Oblast: 'OBLAST',
    SubDistrict: 'SUB_DISTRICT',
    Canton: 'CANTON',
    Municipality: 'MUNICIPALITY',
    Corregimiento: 'CORREGIMIENTO',
    City: 'CITY',
    Town: 'TOWN',
    Village: 'VILLAGE',
    Commune: 'COMMUNE',
    Parish: 'PARISH',
    ZoneNumber: 'ZONE_NUMBER',
    Suburb: 'SUBURB',
    Neighborhood: 'NEIGHBORHOOD',
    RuralDeliveryNumber: 'RURAL_DELIVERY_NUMBER'
} as const;

export type AddressFieldKindEnum = typeof AddressFieldKindEnum[keyof typeof AddressFieldKindEnum];

/**
 * 
 * @export
 * @interface AddressFieldGroup
 */
export interface AddressFieldGroup {
    /**
     * 
     * @type {string}
     * @memberof AddressFieldGroup
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressFieldGroup
     */
    'order'?: number;
    /**
     * 
     * @type {Array<AddressField>}
     * @memberof AddressFieldGroup
     */
    'addressField'?: Array<AddressField>;
}
/**
 * 
 * @export
 * @interface AddressMetadata
 */
export interface AddressMetadata {
    /**
     * 
     * @type {number}
     * @memberof AddressMetadata
     */
    'storeId'?: number;
    /**
     * 
     * @type {Array<CountryMetadata>}
     * @memberof AddressMetadata
     */
    'countryMetadata'?: Array<CountryMetadata>;
}
/**
 * 
 * @export
 * @interface BooleanConditionalPatternConstraint
 */
export interface BooleanConditionalPatternConstraint {
    /**
     * 
     * @type {string}
     * @memberof BooleanConditionalPatternConstraint
     */
    'conditionedBy'?: string;
    /**
     * 
     * @type {Array<BooleanConditionedPattern>}
     * @memberof BooleanConditionalPatternConstraint
     */
    'values'?: Array<BooleanConditionedPattern>;
}
/**
 * 
 * @export
 * @interface BooleanConditionedPattern
 */
export interface BooleanConditionedPattern {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanConditionedPattern
     */
    'conditioningValue'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BooleanConditionedPattern
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface BooleanConstraints
 */
export interface BooleanConstraints {
    /**
     * 
     * @type {string}
     * @memberof BooleanConstraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {object}
     * @memberof BooleanConstraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof BooleanConstraints
     */
    'forbiddenValuesConstraint'?: Array<boolean>;
    /**
     * 
     * @type {object}
     * @memberof BooleanConstraints
     */
    'notSupportedConstraint'?: object;
}
/**
 * 
 * @export
 * @interface BooleanDataType
 */
export interface BooleanDataType {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanDataType
     */
    'defaultValue'?: boolean;
    /**
     * 
     * @type {Array<BooleanConstraints>}
     * @memberof BooleanDataType
     */
    'constraints'?: Array<BooleanConstraints>;
}
/**
 * 
 * @export
 * @interface CollectionConstraints
 */
export interface CollectionConstraints {
    /**
     * 
     * @type {string}
     * @memberof CollectionConstraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {object}
     * @memberof CollectionConstraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {LengthConstraint}
     * @memberof CollectionConstraints
     */
    'lengthConstraint'?: LengthConstraint;
    /**
     * 
     * @type {object}
     * @memberof CollectionConstraints
     */
    'notSupportedConstraint'?: object;
}
/**
 * 
 * @export
 * @interface CollectionDataType
 */
export interface CollectionDataType {
    /**
     * 
     * @type {Array<CollectionConstraints>}
     * @memberof CollectionDataType
     */
    'constraints'?: Array<CollectionConstraints>;
    /**
     * 
     * @type {Int32DataType}
     * @memberof CollectionDataType
     */
    'int32DataType'?: Int32DataType;
    /**
     * 
     * @type {Int64DataType}
     * @memberof CollectionDataType
     */
    'int64DataType'?: Int64DataType;
    /**
     * 
     * @type {StringDataType}
     * @memberof CollectionDataType
     */
    'stringDataType'?: StringDataType;
    /**
     * 
     * @type {BooleanDataType}
     * @memberof CollectionDataType
     */
    'booleanDataType'?: BooleanDataType;
    /**
     * 
     * @type {ComplexObjectDataType}
     * @memberof CollectionDataType
     */
    'complexDataType'?: ComplexObjectDataType;
}
/**
 * 
 * @export
 * @interface ComplexObjectConstraints
 */
export interface ComplexObjectConstraints {
    /**
     * 
     * @type {string}
     * @memberof ComplexObjectConstraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {object}
     * @memberof ComplexObjectConstraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {object}
     * @memberof ComplexObjectConstraints
     */
    'notSupportedConstraint'?: object;
}
/**
 * 
 * @export
 * @interface ComplexObjectDataType
 */
export interface ComplexObjectDataType {
    /**
     * 
     * @type {Array<ComplexObjectConstraints>}
     * @memberof ComplexObjectDataType
     */
    'constraints'?: Array<ComplexObjectConstraints>;
}
/**
 * 
 * @export
 * @interface CountryMetadata
 */
export interface CountryMetadata {
    /**
     * 
     * @type {string}
     * @memberof CountryMetadata
     */
    'countryCode'?: string;
    /**
     * 
     * @type {Array<Localization>}
     * @memberof CountryMetadata
     */
    'countryName'?: Array<Localization>;
    /**
     * 
     * @type {Array<AddressFieldGroup>}
     * @memberof CountryMetadata
     */
    'metadataAddressFieldGroup'?: Array<AddressFieldGroup>;
    /**
     * 
     * @type {boolean}
     * @memberof CountryMetadata
     */
    'primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CountryMetadata
     */
    'usesTemplate'?: boolean;
}
/**
 * 
 * @export
 * @interface DropPoint
 */
export interface DropPoint {
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'datatype'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DropPoint
     */
    'addressLines'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'countryCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'district'?: string;
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'provinceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof DropPoint
     */
    'zipCode'?: string;
    /**
     * 
     * @type {PickUpPoint}
     * @memberof DropPoint
     */
    'pickUpPoint'?: PickUpPoint;
    /**
     * 
     * @type {boolean}
     * @memberof DropPoint
     */
    'isAnonymized'?: boolean;
}
/**
 * 
 * @export
 * @interface DropPointList
 */
export interface DropPointList {
    /**
     * 
     * @type {Array<DropPoint>}
     * @memberof DropPointList
     */
    'dropPoints'?: Array<DropPoint>;
    /**
     * 
     * @type {number}
     * @memberof DropPointList
     */
    'radius'?: number;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'detail'?: string;
    /**
     * 
     * @type {AdditionalData}
     * @memberof ErrorResponse
     */
    'additionalData'?: AdditionalData;
}
/**
 * 
 * @export
 * @interface Int32ByBooleanFilterableSetConstraint
 */
export interface Int32ByBooleanFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int32ByBooleanFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int32ByBooleanFilterableValues>}
     * @memberof Int32ByBooleanFilterableSetConstraint
     */
    'values'?: Array<Int32ByBooleanFilterableValues>;
}
/**
 * 
 * @export
 * @interface Int32ByBooleanFilterableValues
 */
export interface Int32ByBooleanFilterableValues {
    /**
     * 
     * @type {boolean}
     * @memberof Int32ByBooleanFilterableValues
     */
    'key'?: boolean;
    /**
     * 
     * @type {Array<Int32FilterableValue>}
     * @memberof Int32ByBooleanFilterableValues
     */
    'values'?: Array<Int32FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int32ByInt32FilterableSetConstraint
 */
export interface Int32ByInt32FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int32ByInt32FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int32ByInt32FilterableValues>}
     * @memberof Int32ByInt32FilterableSetConstraint
     */
    'values'?: Array<Int32ByInt32FilterableValues>;
}
/**
 * 
 * @export
 * @interface Int32ByInt32FilterableValues
 */
export interface Int32ByInt32FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof Int32ByInt32FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<Int32FilterableValue>}
     * @memberof Int32ByInt32FilterableValues
     */
    'values'?: Array<Int32FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int32ByInt64FilterableSetConstraint
 */
export interface Int32ByInt64FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int32ByInt64FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int32ByInt64FilterableValues>}
     * @memberof Int32ByInt64FilterableSetConstraint
     */
    'values'?: Array<Int32ByInt64FilterableValues>;
}
/**
 * 
 * @export
 * @interface Int32ByInt64FilterableValues
 */
export interface Int32ByInt64FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof Int32ByInt64FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<Int32FilterableValue>}
     * @memberof Int32ByInt64FilterableValues
     */
    'values'?: Array<Int32FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int32ByStringFilterableSetConstraint
 */
export interface Int32ByStringFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int32ByStringFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int32ByStringFilterableValues>}
     * @memberof Int32ByStringFilterableSetConstraint
     */
    'values'?: Array<Int32ByStringFilterableValues>;
}
/**
 * 
 * @export
 * @interface Int32ByStringFilterableValues
 */
export interface Int32ByStringFilterableValues {
    /**
     * 
     * @type {string}
     * @memberof Int32ByStringFilterableValues
     */
    'key'?: string;
    /**
     * 
     * @type {Array<Int32FilterableValue>}
     * @memberof Int32ByStringFilterableValues
     */
    'values'?: Array<Int32FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int32ConditionalPatternConstraint
 */
export interface Int32ConditionalPatternConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int32ConditionalPatternConstraint
     */
    'conditionedBy'?: string;
    /**
     * 
     * @type {Array<Int32ConditionedPattern>}
     * @memberof Int32ConditionalPatternConstraint
     */
    'values'?: Array<Int32ConditionedPattern>;
}
/**
 * 
 * @export
 * @interface Int32ConditionedPattern
 */
export interface Int32ConditionedPattern {
    /**
     * 
     * @type {number}
     * @memberof Int32ConditionedPattern
     */
    'conditioningValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32ConditionedPattern
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface Int32Constraints
 */
export interface Int32Constraints {
    /**
     * 
     * @type {string}
     * @memberof Int32Constraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {Int32ByInt32FilterableSetConstraint}
     * @memberof Int32Constraints
     */
    'byInt32FilterableSetConstraint'?: Int32ByInt32FilterableSetConstraint;
    /**
     * 
     * @type {Int32ByInt64FilterableSetConstraint}
     * @memberof Int32Constraints
     */
    'byInt64FilterableSetConstraint'?: Int32ByInt64FilterableSetConstraint;
    /**
     * 
     * @type {Int32ByStringFilterableSetConstraint}
     * @memberof Int32Constraints
     */
    'byStringFilterableSetConstraint'?: Int32ByStringFilterableSetConstraint;
    /**
     * 
     * @type {Int32ByBooleanFilterableSetConstraint}
     * @memberof Int32Constraints
     */
    'byBooleanFilterableSetConstraint'?: Int32ByBooleanFilterableSetConstraint;
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32Constraints
     */
    'setConstraint'?: Array<number>;
    /**
     * 
     * @type {LengthConstraint}
     * @memberof Int32Constraints
     */
    'lengthConstraint'?: LengthConstraint;
    /**
     * 
     * @type {object}
     * @memberof Int32Constraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {Array<number>}
     * @memberof Int32Constraints
     */
    'forbiddenValuesConstraint'?: Array<number>;
    /**
     * 
     * @type {object}
     * @memberof Int32Constraints
     */
    'notSupportedConstraint'?: object;
    /**
     * 
     * @type {object}
     * @memberof Int32Constraints
     */
    'algorithmicConstraint'?: object;
}
/**
 * 
 * @export
 * @interface Int32DataType
 */
export interface Int32DataType {
    /**
     * 
     * @type {number}
     * @memberof Int32DataType
     */
    'defaultValue'?: number;
    /**
     * Format to apply to the field
     * @type {string}
     * @memberof Int32DataType
     */
    'formatMask'?: string;
    /**
     * 
     * @type {Array<Int32Constraints>}
     * @memberof Int32DataType
     */
    'constraints'?: Array<Int32Constraints>;
}
/**
 * 
 * @export
 * @interface Int32FilterableValue
 */
export interface Int32FilterableValue {
    /**
     * 
     * @type {number}
     * @memberof Int32FilterableValue
     */
    'value'?: number;
    /**
     * 
     * @type {Array<Localization>}
     * @memberof Int32FilterableValue
     */
    'localizations'?: Array<Localization>;
}
/**
 * 
 * @export
 * @interface Int64ByBooleanFilterableSetConstraint
 */
export interface Int64ByBooleanFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int64ByBooleanFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int64ByBooleanFilterableValues>}
     * @memberof Int64ByBooleanFilterableSetConstraint
     */
    'values'?: Array<Int64ByBooleanFilterableValues>;
}
/**
 * 
 * @export
 * @interface Int64ByBooleanFilterableValues
 */
export interface Int64ByBooleanFilterableValues {
    /**
     * 
     * @type {boolean}
     * @memberof Int64ByBooleanFilterableValues
     */
    'key'?: boolean;
    /**
     * 
     * @type {Array<Int64FilterableValue>}
     * @memberof Int64ByBooleanFilterableValues
     */
    'values'?: Array<Int64FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int64ByInt32FilterableSetConstraint
 */
export interface Int64ByInt32FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int64ByInt32FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int64ByInt32FilterableValues>}
     * @memberof Int64ByInt32FilterableSetConstraint
     */
    'values'?: Array<Int64ByInt32FilterableValues>;
}
/**
 * 
 * @export
 * @interface Int64ByInt32FilterableValues
 */
export interface Int64ByInt32FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof Int64ByInt32FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<Int64FilterableValue>}
     * @memberof Int64ByInt32FilterableValues
     */
    'values'?: Array<Int64FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int64ByInt64FilterableSetConstraint
 */
export interface Int64ByInt64FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int64ByInt64FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int64ByInt64FilterableValues>}
     * @memberof Int64ByInt64FilterableSetConstraint
     */
    'values'?: Array<Int64ByInt64FilterableValues>;
}
/**
 * 
 * @export
 * @interface Int64ByInt64FilterableValues
 */
export interface Int64ByInt64FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof Int64ByInt64FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<Int64FilterableValue>}
     * @memberof Int64ByInt64FilterableValues
     */
    'values'?: Array<Int64FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int64ByStringFilterableSetConstraint
 */
export interface Int64ByStringFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int64ByStringFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<Int64ByStringFilterableValues>}
     * @memberof Int64ByStringFilterableSetConstraint
     */
    'values'?: Array<Int64ByStringFilterableValues>;
}
/**
 * 
 * @export
 * @interface Int64ByStringFilterableValues
 */
export interface Int64ByStringFilterableValues {
    /**
     * 
     * @type {string}
     * @memberof Int64ByStringFilterableValues
     */
    'key'?: string;
    /**
     * 
     * @type {Array<Int64FilterableValue>}
     * @memberof Int64ByStringFilterableValues
     */
    'values'?: Array<Int64FilterableValue>;
}
/**
 * 
 * @export
 * @interface Int64ConditionalPatternConstraint
 */
export interface Int64ConditionalPatternConstraint {
    /**
     * 
     * @type {string}
     * @memberof Int64ConditionalPatternConstraint
     */
    'conditionedBy'?: string;
    /**
     * 
     * @type {Array<Int64ConditionedPattern>}
     * @memberof Int64ConditionalPatternConstraint
     */
    'values'?: Array<Int64ConditionedPattern>;
}
/**
 * 
 * @export
 * @interface Int64ConditionedPattern
 */
export interface Int64ConditionedPattern {
    /**
     * 
     * @type {number}
     * @memberof Int64ConditionedPattern
     */
    'conditioningValue'?: number;
    /**
     * 
     * @type {string}
     * @memberof Int64ConditionedPattern
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface Int64Constraints
 */
export interface Int64Constraints {
    /**
     * 
     * @type {string}
     * @memberof Int64Constraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {Int64ByInt32FilterableSetConstraint}
     * @memberof Int64Constraints
     */
    'byInt32FilterableSetConstraint'?: Int64ByInt32FilterableSetConstraint;
    /**
     * 
     * @type {Int64ByInt64FilterableSetConstraint}
     * @memberof Int64Constraints
     */
    'byInt64FilterableSetConstraint'?: Int64ByInt64FilterableSetConstraint;
    /**
     * 
     * @type {Int64ByStringFilterableSetConstraint}
     * @memberof Int64Constraints
     */
    'byStringFilterableSetConstraint'?: Int64ByStringFilterableSetConstraint;
    /**
     * 
     * @type {Int64ByBooleanFilterableSetConstraint}
     * @memberof Int64Constraints
     */
    'byBooleanFilterableSetConstraint'?: Int64ByBooleanFilterableSetConstraint;
    /**
     * 
     * @type {Array<number>}
     * @memberof Int64Constraints
     */
    'setConstraint'?: Array<number>;
    /**
     * 
     * @type {LengthConstraint}
     * @memberof Int64Constraints
     */
    'lengthConstraint'?: LengthConstraint;
    /**
     * 
     * @type {object}
     * @memberof Int64Constraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {Array<number>}
     * @memberof Int64Constraints
     */
    'forbiddenValuesConstraint'?: Array<number>;
    /**
     * 
     * @type {object}
     * @memberof Int64Constraints
     */
    'notSupportedConstraint'?: object;
    /**
     * 
     * @type {object}
     * @memberof Int64Constraints
     */
    'algorithmicConstraint'?: object;
}
/**
 * 
 * @export
 * @interface Int64DataType
 */
export interface Int64DataType {
    /**
     * 
     * @type {number}
     * @memberof Int64DataType
     */
    'defaultValue'?: number;
    /**
     * Format to apply to the field
     * @type {string}
     * @memberof Int64DataType
     */
    'formatMask'?: string;
    /**
     * 
     * @type {Array<Int64Constraints>}
     * @memberof Int64DataType
     */
    'constraints'?: Array<Int64Constraints>;
}
/**
 * 
 * @export
 * @interface Int64FilterableValue
 */
export interface Int64FilterableValue {
    /**
     * 
     * @type {number}
     * @memberof Int64FilterableValue
     */
    'value'?: number;
    /**
     * 
     * @type {Array<Localization>}
     * @memberof Int64FilterableValue
     */
    'localizations'?: Array<Localization>;
}
/**
 * 
 * @export
 * @interface LengthConstraint
 */
export interface LengthConstraint {
    /**
     * 
     * @type {number}
     * @memberof LengthConstraint
     */
    'minLength'?: number;
    /**
     * 
     * @type {number}
     * @memberof LengthConstraint
     */
    'maxLength'?: number;
}
/**
 * 
 * @export
 * @interface Localization
 */
export interface Localization {
    /**
     * 
     * @type {string}
     * @memberof Localization
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof Localization
     */
    'value'?: string;
}
/**
 * 
 * @export
 * @interface OpeningHours
 */
export interface OpeningHours {
    /**
     * 
     * @type {string}
     * @memberof OpeningHours
     */
    'datatype'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHours
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof OpeningHours
     */
    'weekDay'?: number;
    /**
     * 
     * @type {Array<OpeningHoursInterval>}
     * @memberof OpeningHours
     */
    'openingHoursInterval'?: Array<OpeningHoursInterval>;
}
/**
 * 
 * @export
 * @interface OpeningHoursInterval
 */
export interface OpeningHoursInterval {
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'datatype'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'openTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof OpeningHoursInterval
     */
    'closeTime'?: string;
}
/**
 * 
 * @export
 * @interface Parameter
 */
export interface Parameter {
    /**
     * 
     * @type {string}
     * @memberof Parameter
     */
    'kind'?: string;
    /**
     * 
     * @type {string}
     * @memberof Parameter
     */
    'validRegexp'?: string;
}
/**
 * 
 * @export
 * @interface PickUpPoint
 */
export interface PickUpPoint {
    /**
     * 
     * @type {string}
     * @memberof PickUpPoint
     */
    'destinationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PickUpPoint
     */
    'destinationName'?: string;
    /**
     * 
     * @type {number}
     * @memberof PickUpPoint
     */
    'destinationLatitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof PickUpPoint
     */
    'destinationLongitude'?: number;
    /**
     * 
     * @type {number}
     * @memberof PickUpPoint
     */
    'dropPointId'?: number;
    /**
     * 
     * @type {Array<Parameter>}
     * @memberof PickUpPoint
     */
    'extraParams'?: Array<Parameter>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof PickUpPoint
     */
    'extraInfo'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof PickUpPoint
     */
    'networkTypeCode'?: string;
    /**
     * 
     * @type {Array<OpeningHours>}
     * @memberof PickUpPoint
     */
    'openingHours'?: Array<OpeningHours>;
    /**
     * 
     * @type {string}
     * @memberof PickUpPoint
     */
    'courierName': string;
    /**
     * 
     * @type {string}
     * @memberof PickUpPoint
     */
    'courierCode': string;
    /**
     * 
     * @type {PickUpPointIconUrls}
     * @memberof PickUpPoint
     */
    'iconUrls': PickUpPointIconUrls;
}
/**
 * 
 * @export
 * @interface PickUpPointIconUrls
 */
export interface PickUpPointIconUrls {
    /**
     * 
     * @type {string}
     * @memberof PickUpPointIconUrls
     */
    'base': string;
    /**
     * 
     * @type {string}
     * @memberof PickUpPointIconUrls
     */
    'selected': string;
}
/**
 * 
 * @export
 * @interface StringByBooleanFilterableSetConstraint
 */
export interface StringByBooleanFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof StringByBooleanFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<StringByBooleanFilterableValues>}
     * @memberof StringByBooleanFilterableSetConstraint
     */
    'values'?: Array<StringByBooleanFilterableValues>;
}
/**
 * 
 * @export
 * @interface StringByBooleanFilterableValues
 */
export interface StringByBooleanFilterableValues {
    /**
     * 
     * @type {boolean}
     * @memberof StringByBooleanFilterableValues
     */
    'key'?: boolean;
    /**
     * 
     * @type {Array<StringFilterableValue>}
     * @memberof StringByBooleanFilterableValues
     */
    'values'?: Array<StringFilterableValue>;
}
/**
 * 
 * @export
 * @interface StringByInt32FilterableSetConstraint
 */
export interface StringByInt32FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof StringByInt32FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<StringByInt32FilterableValues>}
     * @memberof StringByInt32FilterableSetConstraint
     */
    'values'?: Array<StringByInt32FilterableValues>;
}
/**
 * 
 * @export
 * @interface StringByInt32FilterableValues
 */
export interface StringByInt32FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof StringByInt32FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<StringFilterableValue>}
     * @memberof StringByInt32FilterableValues
     */
    'values'?: Array<StringFilterableValue>;
}
/**
 * 
 * @export
 * @interface StringByInt64FilterableSetConstraint
 */
export interface StringByInt64FilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof StringByInt64FilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<StringByInt64FilterableValues>}
     * @memberof StringByInt64FilterableSetConstraint
     */
    'values'?: Array<StringByInt64FilterableValues>;
}
/**
 * 
 * @export
 * @interface StringByInt64FilterableValues
 */
export interface StringByInt64FilterableValues {
    /**
     * 
     * @type {number}
     * @memberof StringByInt64FilterableValues
     */
    'key'?: number;
    /**
     * 
     * @type {Array<StringFilterableValue>}
     * @memberof StringByInt64FilterableValues
     */
    'values'?: Array<StringFilterableValue>;
}
/**
 * 
 * @export
 * @interface StringByStringFilterableSetConstraint
 */
export interface StringByStringFilterableSetConstraint {
    /**
     * 
     * @type {string}
     * @memberof StringByStringFilterableSetConstraint
     */
    'filterBy'?: string;
    /**
     * 
     * @type {Array<StringByStringFilterableValues>}
     * @memberof StringByStringFilterableSetConstraint
     */
    'values'?: Array<StringByStringFilterableValues>;
}
/**
 * 
 * @export
 * @interface StringByStringFilterableValues
 */
export interface StringByStringFilterableValues {
    /**
     * 
     * @type {string}
     * @memberof StringByStringFilterableValues
     */
    'key'?: string;
    /**
     * 
     * @type {Array<StringFilterableValue>}
     * @memberof StringByStringFilterableValues
     */
    'values'?: Array<StringFilterableValue>;
}
/**
 * 
 * @export
 * @interface StringConditionalPatternConstraint
 */
export interface StringConditionalPatternConstraint {
    /**
     * 
     * @type {string}
     * @memberof StringConditionalPatternConstraint
     */
    'conditionedBy'?: string;
    /**
     * 
     * @type {Array<StringConditionedPattern>}
     * @memberof StringConditionalPatternConstraint
     */
    'values'?: Array<StringConditionedPattern>;
}
/**
 * 
 * @export
 * @interface StringConditionedPattern
 */
export interface StringConditionedPattern {
    /**
     * 
     * @type {string}
     * @memberof StringConditionedPattern
     */
    'conditioningValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringConditionedPattern
     */
    'pattern'?: string;
}
/**
 * 
 * @export
 * @interface StringConstraints
 */
export interface StringConstraints {
    /**
     * 
     * @type {string}
     * @memberof StringConstraints
     */
    'constraintId'?: string;
    /**
     * 
     * @type {StringByInt32FilterableSetConstraint}
     * @memberof StringConstraints
     */
    'byInt32FilterableSetConstraint'?: StringByInt32FilterableSetConstraint;
    /**
     * 
     * @type {StringByInt64FilterableSetConstraint}
     * @memberof StringConstraints
     */
    'byInt64FilterableSetConstraint'?: StringByInt64FilterableSetConstraint;
    /**
     * 
     * @type {StringByStringFilterableSetConstraint}
     * @memberof StringConstraints
     */
    'byStringFilterableSetConstraint'?: StringByStringFilterableSetConstraint;
    /**
     * 
     * @type {StringByBooleanFilterableSetConstraint}
     * @memberof StringConstraints
     */
    'byBooleanFilterableSetConstraint'?: StringByBooleanFilterableSetConstraint;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringConstraints
     */
    'setConstraint'?: Array<string>;
    /**
     * 
     * @type {LengthConstraint}
     * @memberof StringConstraints
     */
    'lengthConstraint'?: LengthConstraint;
    /**
     * 
     * @type {object}
     * @memberof StringConstraints
     */
    'notEmptyConstraint'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringConstraints
     */
    'forbiddenValuesConstraint'?: Array<string>;
    /**
     * 
     * @type {object}
     * @memberof StringConstraints
     */
    'notSupportedConstraint'?: object;
    /**
     * 
     * @type {object}
     * @memberof StringConstraints
     */
    'algorithmicConstraint'?: object;
    /**
     * 
     * @type {string}
     * @memberof StringConstraints
     */
    'patternConstraint'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringConstraints
     */
    'forbiddenPatternConstraint'?: string;
    /**
     * 
     * @type {Int32ConditionalPatternConstraint}
     * @memberof StringConstraints
     */
    'int32ConditionalPatternConstraint'?: Int32ConditionalPatternConstraint;
    /**
     * 
     * @type {Int64ConditionalPatternConstraint}
     * @memberof StringConstraints
     */
    'int64ConditionalPatternConstraint'?: Int64ConditionalPatternConstraint;
    /**
     * 
     * @type {StringConditionalPatternConstraint}
     * @memberof StringConstraints
     */
    'stringConditionalPatternConstraint'?: StringConditionalPatternConstraint;
    /**
     * 
     * @type {BooleanConditionalPatternConstraint}
     * @memberof StringConstraints
     */
    'booleanConditionalPatternConstraint'?: BooleanConditionalPatternConstraint;
}
/**
 * 
 * @export
 * @interface StringDataType
 */
export interface StringDataType {
    /**
     * 
     * @type {string}
     * @memberof StringDataType
     */
    'defaultValue'?: string;
    /**
     * Format to apply to the field
     * @type {string}
     * @memberof StringDataType
     */
    'formatMask'?: string;
    /**
     * 
     * @type {Array<StringConstraints>}
     * @memberof StringDataType
     */
    'constraints'?: Array<StringConstraints>;
}
/**
 * 
 * @export
 * @interface StringFilterableValue
 */
export interface StringFilterableValue {
    /**
     * 
     * @type {string}
     * @memberof StringFilterableValue
     */
    'value'?: string;
    /**
     * 
     * @type {Array<Localization>}
     * @memberof StringFilterableValue
     */
    'localizations'?: Array<Localization>;
}

/**
 * AddressApi - axios parameter creator
 * @export
 */
export const AddressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get method that defines the requested parameters for a given store address forms
         * @summary Get requested parameters for a store id
         * @param {string} storeId Store\&#39;s unique identifier. This field is mandatory, so it can\&#39;t be empty nor null.
         * @param {string} [locale] Locale string as ll-CC where ll is Language ISO code 639 alpha 1 or 2 and CC is Country ISO code 3166 alpha 1.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreMetadata: async (storeId: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStoreMetadata', 'storeId', storeId)
            const localVarPath = `/address-core-metadata/v1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressApi - functional programming interface
 * @export
 */
export const AddressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressApiAxiosParamCreator(configuration)
    return {
        /**
         * Get method that defines the requested parameters for a given store address forms
         * @summary Get requested parameters for a store id
         * @param {string} storeId Store\&#39;s unique identifier. This field is mandatory, so it can\&#39;t be empty nor null.
         * @param {string} [locale] Locale string as ll-CC where ll is Language ISO code 639 alpha 1 or 2 and CC is Country ISO code 3166 alpha 1.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreMetadata(storeId: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddressMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreMetadata(storeId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AddressApi - factory interface
 * @export
 */
export const AddressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressApiFp(configuration)
    return {
        /**
         * Get method that defines the requested parameters for a given store address forms
         * @summary Get requested parameters for a store id
         * @param {string} storeId Store\&#39;s unique identifier. This field is mandatory, so it can\&#39;t be empty nor null.
         * @param {string} [locale] Locale string as ll-CC where ll is Language ISO code 639 alpha 1 or 2 and CC is Country ISO code 3166 alpha 1.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreMetadata(storeId: string, locale?: string, options?: any): AxiosPromise<AddressMetadata> {
            return localVarFp.getStoreMetadata(storeId, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressApi - interface
 * @export
 * @interface AddressApi
 */
export interface AddressApiInterface {
    /**
     * Get method that defines the requested parameters for a given store address forms
     * @summary Get requested parameters for a store id
     * @param {string} storeId Store\&#39;s unique identifier. This field is mandatory, so it can\&#39;t be empty nor null.
     * @param {string} [locale] Locale string as ll-CC where ll is Language ISO code 639 alpha 1 or 2 and CC is Country ISO code 3166 alpha 1.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApiInterface
     */
    getStoreMetadata(storeId: string, locale?: string, options?: AxiosRequestConfig): AxiosPromise<AddressMetadata>;

}

/**
 * AddressApi - object-oriented interface
 * @export
 * @class AddressApi
 * @extends {BaseAPI}
 */
export class AddressApi extends BaseAPI implements AddressApiInterface {
    /**
     * Get method that defines the requested parameters for a given store address forms
     * @summary Get requested parameters for a store id
     * @param {string} storeId Store\&#39;s unique identifier. This field is mandatory, so it can\&#39;t be empty nor null.
     * @param {string} [locale] Locale string as ll-CC where ll is Language ISO code 639 alpha 1 or 2 and CC is Country ISO code 3166 alpha 1.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressApi
     */
    public getStoreMetadata(storeId: string, locale?: string, options?: AxiosRequestConfig) {
        return AddressApiFp(this.configuration).getStoreMetadata(storeId, locale, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DroppointApi - axios parameter creator
 * @export
 */
export const DroppointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * GET method to retrieve a droppoint
         * @summary Get a drop point by ID
         * @param {string} dropPointId 
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] 
         * @param {string} [countryIso] Country ISO. Required if there isn\&#39;t storeId
         * @param {string} [storeId] Store ID. Required if there isn\&#39;t countryIso
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDropPoint: async (dropPointId: string, deviceChannel: string, deviceType: string, userId?: string, countryIso?: string, storeId?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dropPointId' is not null or undefined
            assertParamExists('getDropPoint', 'dropPointId', dropPointId)
            // verify required parameter 'deviceChannel' is not null or undefined
            assertParamExists('getDropPoint', 'deviceChannel', deviceChannel)
            // verify required parameter 'deviceType' is not null or undefined
            assertParamExists('getDropPoint', 'deviceType', deviceType)
            const localVarPath = `/droppoints/v1/{dropPointId}`
                .replace(`{${"dropPointId"}}`, encodeURIComponent(String(dropPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (countryIso !== undefined) {
                localVarQueryParameter['countryIso'] = countryIso;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (userId != null) {
                localVarHeaderParameter['userId'] = String(userId);
            }

            if (deviceChannel != null) {
                localVarHeaderParameter['device-channel'] = String(deviceChannel);
            }

            if (deviceType != null) {
                localVarHeaderParameter['device-type'] = String(deviceType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DroppointApi - functional programming interface
 * @export
 */
export const DroppointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DroppointApiAxiosParamCreator(configuration)
    return {
        /**
         * GET method to retrieve a droppoint
         * @summary Get a drop point by ID
         * @param {string} dropPointId 
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] 
         * @param {string} [countryIso] Country ISO. Required if there isn\&#39;t storeId
         * @param {string} [storeId] Store ID. Required if there isn\&#39;t countryIso
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDropPoint(dropPointId: string, deviceChannel: string, deviceType: string, userId?: string, countryIso?: string, storeId?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropPoint>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDropPoint(dropPointId, deviceChannel, deviceType, userId, countryIso, storeId, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DroppointApi - factory interface
 * @export
 */
export const DroppointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DroppointApiFp(configuration)
    return {
        /**
         * GET method to retrieve a droppoint
         * @summary Get a drop point by ID
         * @param {string} dropPointId 
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] 
         * @param {string} [countryIso] Country ISO. Required if there isn\&#39;t storeId
         * @param {string} [storeId] Store ID. Required if there isn\&#39;t countryIso
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDropPoint(dropPointId: string, deviceChannel: string, deviceType: string, userId?: string, countryIso?: string, storeId?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', options?: any): AxiosPromise<DropPoint> {
            return localVarFp.getDropPoint(dropPointId, deviceChannel, deviceType, userId, countryIso, storeId, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DroppointApi - interface
 * @export
 * @interface DroppointApi
 */
export interface DroppointApiInterface {
    /**
     * GET method to retrieve a droppoint
     * @summary Get a drop point by ID
     * @param {string} dropPointId 
     * @param {string} deviceChannel 
     * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
     * @param {string} [userId] 
     * @param {string} [countryIso] Country ISO. Required if there isn\&#39;t storeId
     * @param {string} [storeId] Store ID. Required if there isn\&#39;t countryIso
     * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DroppointApiInterface
     */
    getDropPoint(dropPointId: string, deviceChannel: string, deviceType: string, userId?: string, countryIso?: string, storeId?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', options?: AxiosRequestConfig): AxiosPromise<DropPoint>;

}

/**
 * DroppointApi - object-oriented interface
 * @export
 * @class DroppointApi
 * @extends {BaseAPI}
 */
export class DroppointApi extends BaseAPI implements DroppointApiInterface {
    /**
     * GET method to retrieve a droppoint
     * @summary Get a drop point by ID
     * @param {string} dropPointId 
     * @param {string} deviceChannel 
     * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
     * @param {string} [userId] 
     * @param {string} [countryIso] Country ISO. Required if there isn\&#39;t storeId
     * @param {string} [storeId] Store ID. Required if there isn\&#39;t countryIso
     * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DroppointApi
     */
    public getDropPoint(dropPointId: string, deviceChannel: string, deviceType: string, userId?: string, countryIso?: string, storeId?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', options?: AxiosRequestConfig) {
        return DroppointApiFp(this.configuration).getDropPoint(dropPointId, deviceChannel, deviceType, userId, countryIso, storeId, type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DroppointsApi - axios parameter creator
 * @export
 */
export const DroppointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get method to retrieve a list of droppoints
         * @summary Get a list of drop points
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] Unique code that identifies the owner.
         * @param {string} [storeId] This field is mandatory if countryIso is not informed.
         * @param {number} [latitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, longitude must be informed too.
         * @param {number} [longitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, latitude must be informed too.
         * @param {number} [radius] 
         * @param {number} [max] If value is greater than 100 or it\&#39;s not informed, only get 100 droppoints.
         * @param {string} [countryIso] This field is mandatory if storeId is not informed.
         * @param {string} [city] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [provinceCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [district] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [zipCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [addressName] Street name for query.
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {string} [serviceType] Service type
         * @param {string} [originCountryCode] The origin country ISO code for C2C defined by ISO 3166-1 alpha 2 standard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDropPoints: async (deviceChannel: string, deviceType: string, userId?: string, storeId?: string, latitude?: number, longitude?: number, radius?: number, max?: number, countryIso?: string, city?: string, provinceCode?: string, district?: string, zipCode?: string, addressName?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', serviceType?: string, originCountryCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceChannel' is not null or undefined
            assertParamExists('getDropPoints', 'deviceChannel', deviceChannel)
            // verify required parameter 'deviceType' is not null or undefined
            assertParamExists('getDropPoints', 'deviceType', deviceType)
            const localVarPath = `/droppoints/v1`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ItxApiKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }

            if (max !== undefined) {
                localVarQueryParameter['max'] = max;
            }

            if (countryIso !== undefined) {
                localVarQueryParameter['countryIso'] = countryIso;
            }

            if (city !== undefined) {
                localVarQueryParameter['city'] = city;
            }

            if (provinceCode !== undefined) {
                localVarQueryParameter['provinceCode'] = provinceCode;
            }

            if (district !== undefined) {
                localVarQueryParameter['district'] = district;
            }

            if (zipCode !== undefined) {
                localVarQueryParameter['zipCode'] = zipCode;
            }

            if (addressName !== undefined) {
                localVarQueryParameter['addressName'] = addressName;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (serviceType !== undefined) {
                localVarQueryParameter['serviceType'] = serviceType;
            }

            if (originCountryCode !== undefined) {
                localVarQueryParameter['originCountryCode'] = originCountryCode;
            }

            if (userId != null) {
                localVarHeaderParameter['userId'] = String(userId);
            }

            if (deviceChannel != null) {
                localVarHeaderParameter['device-channel'] = String(deviceChannel);
            }

            if (deviceType != null) {
                localVarHeaderParameter['device-type'] = String(deviceType);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DroppointsApi - functional programming interface
 * @export
 */
export const DroppointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DroppointsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get method to retrieve a list of droppoints
         * @summary Get a list of drop points
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] Unique code that identifies the owner.
         * @param {string} [storeId] This field is mandatory if countryIso is not informed.
         * @param {number} [latitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, longitude must be informed too.
         * @param {number} [longitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, latitude must be informed too.
         * @param {number} [radius] 
         * @param {number} [max] If value is greater than 100 or it\&#39;s not informed, only get 100 droppoints.
         * @param {string} [countryIso] This field is mandatory if storeId is not informed.
         * @param {string} [city] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [provinceCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [district] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [zipCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [addressName] Street name for query.
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {string} [serviceType] Service type
         * @param {string} [originCountryCode] The origin country ISO code for C2C defined by ISO 3166-1 alpha 2 standard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDropPoints(deviceChannel: string, deviceType: string, userId?: string, storeId?: string, latitude?: number, longitude?: number, radius?: number, max?: number, countryIso?: string, city?: string, provinceCode?: string, district?: string, zipCode?: string, addressName?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', serviceType?: string, originCountryCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DropPointList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDropPoints(deviceChannel, deviceType, userId, storeId, latitude, longitude, radius, max, countryIso, city, provinceCode, district, zipCode, addressName, type, serviceType, originCountryCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DroppointsApi - factory interface
 * @export
 */
export const DroppointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DroppointsApiFp(configuration)
    return {
        /**
         * Get method to retrieve a list of droppoints
         * @summary Get a list of drop points
         * @param {string} deviceChannel 
         * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
         * @param {string} [userId] Unique code that identifies the owner.
         * @param {string} [storeId] This field is mandatory if countryIso is not informed.
         * @param {number} [latitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, longitude must be informed too.
         * @param {number} [longitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, latitude must be informed too.
         * @param {number} [radius] 
         * @param {number} [max] If value is greater than 100 or it\&#39;s not informed, only get 100 droppoints.
         * @param {string} [countryIso] This field is mandatory if storeId is not informed.
         * @param {string} [city] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [provinceCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [district] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [zipCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
         * @param {string} [addressName] Street name for query.
         * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
         * @param {string} [serviceType] Service type
         * @param {string} [originCountryCode] The origin country ISO code for C2C defined by ISO 3166-1 alpha 2 standard
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDropPoints(deviceChannel: string, deviceType: string, userId?: string, storeId?: string, latitude?: number, longitude?: number, radius?: number, max?: number, countryIso?: string, city?: string, provinceCode?: string, district?: string, zipCode?: string, addressName?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', serviceType?: string, originCountryCode?: string, options?: any): AxiosPromise<DropPointList> {
            return localVarFp.getDropPoints(deviceChannel, deviceType, userId, storeId, latitude, longitude, radius, max, countryIso, city, provinceCode, district, zipCode, addressName, type, serviceType, originCountryCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DroppointsApi - interface
 * @export
 * @interface DroppointsApi
 */
export interface DroppointsApiInterface {
    /**
     * Get method to retrieve a list of droppoints
     * @summary Get a list of drop points
     * @param {string} deviceChannel 
     * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
     * @param {string} [userId] Unique code that identifies the owner.
     * @param {string} [storeId] This field is mandatory if countryIso is not informed.
     * @param {number} [latitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, longitude must be informed too.
     * @param {number} [longitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, latitude must be informed too.
     * @param {number} [radius] 
     * @param {number} [max] If value is greater than 100 or it\&#39;s not informed, only get 100 droppoints.
     * @param {string} [countryIso] This field is mandatory if storeId is not informed.
     * @param {string} [city] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [provinceCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [district] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [zipCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [addressName] Street name for query.
     * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
     * @param {string} [serviceType] Service type
     * @param {string} [originCountryCode] The origin country ISO code for C2C defined by ISO 3166-1 alpha 2 standard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DroppointsApiInterface
     */
    getDropPoints(deviceChannel: string, deviceType: string, userId?: string, storeId?: string, latitude?: number, longitude?: number, radius?: number, max?: number, countryIso?: string, city?: string, provinceCode?: string, district?: string, zipCode?: string, addressName?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', serviceType?: string, originCountryCode?: string, options?: AxiosRequestConfig): AxiosPromise<DropPointList>;

}

/**
 * DroppointsApi - object-oriented interface
 * @export
 * @class DroppointsApi
 * @extends {BaseAPI}
 */
export class DroppointsApi extends BaseAPI implements DroppointsApiInterface {
    /**
     * Get method to retrieve a list of droppoints
     * @summary Get a list of drop points
     * @param {string} deviceChannel 
     * @param {string} deviceType Type of the device, example [\&quot;mobile\&quot;, \&quot;tablet\&quot;, \&quot;desktop\&quot;, \&quot;smart-tv\&quot;, \&quot;smart-watch\&quot;]
     * @param {string} [userId] Unique code that identifies the owner.
     * @param {string} [storeId] This field is mandatory if countryIso is not informed.
     * @param {number} [latitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, longitude must be informed too.
     * @param {number} [longitude] This field is mandatory if city, provinceCode, district and zipCode are not informed. If it\&#39;s informed, latitude must be informed too.
     * @param {number} [radius] 
     * @param {number} [max] If value is greater than 100 or it\&#39;s not informed, only get 100 droppoints.
     * @param {string} [countryIso] This field is mandatory if storeId is not informed.
     * @param {string} [city] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [provinceCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [district] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [zipCode] At least one of the fields city, provinceCode, district and zipCode should be informed if latitude and longitude are not informed.
     * @param {string} [addressName] Street name for query.
     * @param {'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT'} [type] droppoint type
     * @param {string} [serviceType] Service type
     * @param {string} [originCountryCode] The origin country ISO code for C2C defined by ISO 3166-1 alpha 2 standard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DroppointsApi
     */
    public getDropPoints(deviceChannel: string, deviceType: string, userId?: string, storeId?: string, latitude?: number, longitude?: number, radius?: number, max?: number, countryIso?: string, city?: string, provinceCode?: string, district?: string, zipCode?: string, addressName?: string, type?: 'MULTIPURPOSE_POINT' | 'DELIVERY_POINT' | 'COLLECTION_POINT', serviceType?: string, originCountryCode?: string, options?: AxiosRequestConfig) {
        return DroppointsApiFp(this.configuration).getDropPoints(deviceChannel, deviceType, userId, storeId, latitude, longitude, radius, max, countryIso, city, provinceCode, district, zipCode, addressName, type, serviceType, originCountryCode, options).then((request) => request(this.axios, this.basePath));
    }
}


